module.exports = __webpack_public_path__ + "57950b589242750f627245154c787493.svg";